import App from '@/models/App'
import ShipFeature from '@/models/ShipFeature'

export default class Feature extends App {
    static get entity() {
        return 'features'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static top() {
        return this.query().where('code', 'top').withAllRecursive().first()
    }
    static daily() {
        return this.query().where('code', 'daily').withAllRecursive().first()
    }
    static logbook() {
        return this.query().where('code', 'logbook').withAllRecursive().first()
    }
    static maintenance() {
        return this.query()
            .where('code', 'maintenance')
            .withAllRecursive()
            .first()
    }
    static spares() {
        return this.query().where('code', 'spares').withAllRecursive().first()
    }
    static labor() {
        return this.query().where('code', 'labor').withAllRecursive().first()
    }
    static traffic() {
        return this.query().where('code', 'traffic').withAllRecursive().first()
    }
    static fields() {
        return {
            id: this.attr(''),
            code: this.attr(''),
            ja: this.attr(''),
            en: this.attr(''),
            shipFeatures: this.hasOne(ShipFeature, 'featureId'),
        }
    }
    static apiConfig = {
        actions: {
            fetch(page) {
                return this.get(`/env/feature`, {
                    params: {},
                    headers: {
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
